import { render, staticRenderFns } from "./catDetail.vue?vue&type=template&id=4a416335&scoped=true&"
import script from "./catDetail.vue?vue&type=script&lang=ts&"
export * from "./catDetail.vue?vue&type=script&lang=ts&"
import style0 from "./catDetail.vue?vue&type=style&index=0&id=4a416335&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a416335",
  null
  
)

export default component.exports